import { render, staticRenderFns } from "./RedisCacheConfig.vue?vue&type=template&id=cf825e5e&"
import script from "./RedisCacheConfig.vue?vue&type=script&lang=js&"
export * from "./RedisCacheConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf825e5e')) {
      api.createRecord('cf825e5e', component.options)
    } else {
      api.reload('cf825e5e', component.options)
    }
    module.hot.accept("./RedisCacheConfig.vue?vue&type=template&id=cf825e5e&", function () {
      api.rerender('cf825e5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/RedisCacheConfig.vue"
export default component.exports